import { createContext } from 'react';

export type FieldSetupPanel = 'setup' | 'options';

/**
 * Tab of the Custom Module field setup card the config is rendered under. `null` outside the card,
 * where a config shows every part at once (field config modal, table column editor).
 */
const FieldSetupPanelContext = createContext<FieldSetupPanel | null>(null);

export default FieldSetupPanelContext;
